import { JsonUtils } from '../../utils/json.util'

export class Capture {

    // Capture
    private _responsible: string | undefined
    private _date: string | null | undefined
    private _local: string | undefined

    // capture data
    get responsible(): string | undefined {
        return this._responsible
    }

    set responsible(value: string | undefined) {
        this._responsible = value
    }
    get date(): string | null | undefined {
        return this._date
    }
    set date(value: string | null | undefined) {
        this._date = value
    }
    get local(): string | undefined {
        return this._local
    }

    set local(value: string | undefined) {
        this._local = value
    }

    // metodo responsavel por formatar os dados do backend para frontend
    public fromJSON(json: any): Capture {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        // Capture Data
        if (json.responsible !== undefined) {
            this.responsible = json.responsible
        }
        if (json.date !== undefined) {
            this.date = json.date
        }
        if (json.local !== undefined) {
            this.local = json.local
        }
        return this
    }

    // metodo responsavel para formatar os dados do front para o back
    public toJSON(): any {
        return {
            // Capture
            responsible: this.responsible ,
            date: this.date ,
            local: this.local ,
           // type: this.type !== ExamTypes.NOT_OPTED.toLowerCase() ? this.type : undefined,

        }
    }
}